import { BreakpointTrackerContext } from '@jutro/layout';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect } from 'react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { TranslatorContext } from '@jutro/locale';
import metadata from './AddressDetails.metadata.json5';
import styles from './AddressDetails.module.scss'

function AddressDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { yourHomeVM, locationAddressVM, updateSubmissionVM, 
        updateLocationVM, showErrors, 
        findInvalidComponent, onValidate, isEitherChangeOrRenewal, isLocationStep} = props;
    const translator = useContext(TranslatorContext);
    const ADDRESS_COMPONENT = 'AddressDetails';
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(ADDRESS_COMPONENT);

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, ADDRESS_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        if(findInvalidComponent){
            findInvalidComponent(isComponentValid, ADDRESS_COMPONENT);
        }
    }, [findInvalidComponent, isComponentValid])

    const writeValue = useCallback(
        (value, path) => {
            _.set(locationAddressVM, path, value);

            if(_.includes(path, 'addressLine') && yourHomeVM){
                _.set(yourHomeVM, `primaryAddress_TWIA.${path}.value`,value)
            }

            if(_.includes(path, 'county')){
                // DE15598
                const sameNameCity = _.find(locationAddressVM?.city?.aspects?.availableValues, (val) =>
                    val.code.split(value).length > 2 && !val.code.split(value).some(Boolean)
                )

                if(sameNameCity){
                    _.set(locationAddressVM, 'city.value', sameNameCity?.code);
                }else{
                    _.set(locationAddressVM, 'city.value', undefined);
                }

                _.set(locationAddressVM, 'postalCode.value', undefined);
            }

            if(_.includes(path, 'city')){
                _.set(locationAddressVM, 'postalCode.value', undefined);
            }

            if(_.includes(path, 'postalCode')){
                if(yourHomeVM){
                    // eslint-disable-next-line no-secrets/no-secrets
                _.set(yourHomeVM, 'primaryAddress_TWIA.territoryCode_TWIA.value', undefined);
                // eslint-disable-next-line no-secrets/no-secrets
                _.set(yourHomeVM, 'primaryAddress_TWIA.coastalZoneType_TWIA.value', undefined);
                }

                updateLocationVM(locationAddressVM, true);
            }

            if(yourHomeVM){
                updateSubmissionVM(yourHomeVM);
            }
            
            updateLocationVM(locationAddressVM);
        }, [locationAddressVM, updateLocationVM, updateSubmissionVM, yourHomeVM]
    );

    const getCityAvailableValues = useCallback(() => _.sortBy(
        locationAddressVM.city.aspects.availableValues.map(key => ({
            name: translator({
                id: key.name,
                defaultMessage: key.name,
            }),
            code: key.code,
        }))
    ), [locationAddressVM, translator]);

    const getCountyAvailableValues = useCallback(() => _.sortBy(
        locationAddressVM.county.aspects.availableValues.map(key => ({
            name: translator({
                id: key.name,
                defaultMessage: key.name,
            }),
            code: key.code,
        }))
    ), [locationAddressVM, translator]);

    const getZipCodeAvailableValues = useCallback(() => _.sortBy(
        locationAddressVM.postalCode.aspects.availableValues.map(key => ({
            name: translator({
                id: key.name,
                defaultMessage: key.name,
            }),
            code: key.code,
        }))
    ), [locationAddressVM, translator]);

    const getStateAvailableValues = useCallback(() => _.sortBy(
        locationAddressVM.state.aspects.availableValues.map(key => ({
            name: translator({
                id: key.name,
                defaultMessage: key.name,
            }),
            code: key.code,
        }))
    ), [locationAddressVM, translator]);

    const overrideProps = {
        '@field': {
            // apply to all fields
            // showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
            readOnly: isEitherChangeOrRenewal && !isLocationStep
        },
        city: {
            availableValues: locationAddressVM ? getCityAvailableValues() : [],
            disabled: _.get(locationAddressVM, 'county.value') === undefined
        },
        county: {
            availableValues: locationAddressVM ? getCountyAvailableValues() : []
        },
        zipcode: {
            availableValues: locationAddressVM ? getZipCodeAvailableValues() : [],
            value: _.get(locationAddressVM, 'postalCode.value.code'),
            disabled: _.get(locationAddressVM, 'city.value') === undefined
        },
        state: {
            availableValues: locationAddressVM ? getStateAvailableValues() : [],
            readOnly: isLocationStep || isEitherChangeOrRenewal // DE17136 DE17166   //DE17266
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {
        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={locationAddressVM}
            overrideProps={overrideProps}
            showErrors={showErrors}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            // onModelChange={updateYourHome}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

// AddressDetails.propTypes = wizardProps;
export default AddressDetails;
